<template>
  <div>
    <div class="jumbotron">
      <div class="container marketing">
        <div class="row ">
          <div style="float: right;margin:0 15px 10px 0">
            <router-link to="/service" style="font-weight: 700;font-size: 120%;border-bottom: solid blue 1px">
              返回首页
            </router-link>
          </div>

          <div class="col-lg-7 col-xs-11" style="background: #FFFFFF;border-radius: 5px;margin-left: 15px">
             <span style="float: left" class="col-xs-5 col-lg-3">
                      <img style="padding-top:15px"
                           src="../assets/profile.svg"
                      />
                    </span>
            <div style="float: left;align-content: center">
              <p style="padding: 15px 0 0 5px;font-weight: 600">{{ user.nickname }}</p>
              <span style="padding: 30px 20px 10px 5px">余额:{{ user.balance | toDecimal }}</span>
              <button type="button" v-if="link==''"
                      class="btn btn-primary" style="background:rgb(253,138,26);border: none;margin-bottom: 10px"
                      @click="recharge">
                点击微信充值
              </button>
              <button type="button" v-if="link=='goToMiniPage'"
                      class="btn btn-primary" style="background:rgb(253,138,26);border: none;margin-bottom: 10px"
                      @click="goToMini">
                点击微信充值
              </button>
              <button type="button" v-if="link!==''&& link!=='goToMiniPage'"
                      class="btn btn-primary" style="background:rgb(253,138,26);border: none;margin-bottom: 10px"
                      @click="goToMecheme">
                点击微信充值
              </button>
            </div>
            <div v-if="isWeixin()==true" style="float: left;align-content: center;color: rgb(253,138,26);font-size: 90%">
              <span style="padding: 5px">如果点击充值无反应！【请浏览器打开网页】后可充值！</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <Child1 ref="child"></Child1>
    <!-- <OrderPay ref="pay" v-if="show"></OrderPay> -->
  </div>
</template>
<script>
import {getUserInfo, getWxMiniLink} from "@/api/mine";
import Child1 from '../components/child-1'
import wx from 'weixin-js-sdk'
// import OrderPay from '../components/orderPay'
// import { mapState } from 'vuex'
export default {
  components: {
    Child1,
    // OrderPay
  },
  data() {
    return {
      user: {},
      lists: this.$store.state.user,
      link: '',
    };
  },
  mounted() {
    this.getUser();
    this.getLink();
  },
  methods: {
    getUser() {
      getUserInfo(this.lists.unionid).then((res) => {
        if (res.code == 200) {
          this.user = res.data;
          this.$refs.child.getOrder();
        }
      });
    },
    goToMini() {
      // https://developers.weixin.qq.com/community/develop/doc/74b6835d5cb6865e382674f70a3bea9a
      wx.miniProgram.navigateTo(
          {
            url: './index?uid=' + this.lists.unionid + '&u=' + this.lists.nickname,
            t: this,
            fail: function () {
              this.t.$message.error("1.点击右上角 ... 2.浏览器打开网页后才可以充值哟！");
            }
          }
      );
    },
    goToMecheme() {
      window.open(this.link, "_self");
    },
    isWeixin() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    getLink() {
      if (screen.width < 500) {
        if (this.isWeixin()) {
          this.link = 'goToMiniPage';
          return
        }
        var params = {
          union_id: this.lists.unionid,
          user_name: this.lists.nickname,
        };
        getWxMiniLink(params).then((res) => {
          if (res.code == 200) {
            this.link = res.data;
          }
        });
      }

    },

    recharge() {
      this.$nextTick(() => {
        this.$OrderPayBox()
        // this.$refs.pay.visible = true
      })
    }
  },
};
</script>
<style scoped>
.marketing {
  margin-top: 50px;
}

.recharge {
  color: #ff4c34;
}
</style>